import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive()
export abstract class DestroySubjectBaseDirective implements OnDestroy {
  private _onDestroySubject?: Subject<void>;

  ngOnDestroy(): void {
    if (this._onDestroySubject) {
      this._onDestroySubject.next();
      this._onDestroySubject.complete();
    }
  }

  protected takeUntilDestroy = <T>() => {
    if (!this._onDestroySubject) this._onDestroySubject = new Subject<void>(); // LAZY Subject
    return takeUntil<T>(this._onDestroySubject);
  };
}
